// Portada de la tienda (Ivalro) — scripts propios (vanilla, sin librerías)

function hmInitResenas() {
  var btn = document.querySelector('[data-hm-resenas-toggle]');
  var grid = document.querySelector('[data-hm-resenas-grid]');
  if (!btn || !grid) return;
  btn.addEventListener('click', function () {
    var colapsada = grid.classList.toggle('hm-resenas-colapsada');
    btn.textContent = colapsada ? btn.getAttribute('data-mas') : btn.getAttribute('data-menos');
    btn.setAttribute('aria-expanded', colapsada ? 'false' : 'true');
  });
}

function hmInitReveal() {
  var els = document.querySelectorAll('.hm-reveal, .hm-reveal-stagger');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('hm-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('hm-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.01 }
  );
  els.forEach(function (el) { observer.observe(el); });
  // Salvavidas: si algo queda sin revelar (scroll muy rápido, pestaña en 2º
  // plano al cargar), lo mostramos pasado un tiempo prudencial.
  setTimeout(function () {
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('hm-visible');
    });
  }, 1200);
}

function hmInitFaq() {
  document.querySelectorAll('[data-hm-faq-item]').forEach(function (item) {
    var boton = item.querySelector('[data-hm-faq-toggle]');
    if (!boton) return;
    boton.addEventListener('click', function () {
      var abierto = item.classList.toggle('hm-abierto');
      boton.setAttribute('aria-expanded', abierto ? 'true' : 'false');
    });
  });
}

function hmInitContacto() {
  function validarCampo(input) {
    var campo = input.closest('.hm-campo');
    var errorEl = campo.querySelector('[data-hm-error]');
    var tipo = input.getAttribute('data-hm-validar');
    var valor = input.value.trim();
    var valido = true;
    var mensaje = '';

    var en = (document.documentElement.lang || '').slice(0, 2) === 'en';
    if (!valor) {
      valido = false;
      mensaje = en ? 'This field is required.' : 'Este campo es obligatorio.';
    } else if (tipo === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(valor)) {
      valido = false;
      mensaje = en ? 'Please enter a valid email address.' : 'Escribe un correo electrónico válido.';
    }

    campo.classList.toggle('hm-campo-invalido', !valido);
    if (errorEl) errorEl.textContent = valido ? '' : mensaje;
    return valido;
  }

  document.querySelectorAll('#HMContactForm, #HMSugerenciaForm').forEach(function (form) {
    form.querySelectorAll('[data-hm-validar]').forEach(function (input) {
      input.addEventListener('blur', function () { validarCampo(input); });
      input.addEventListener('input', function () {
        if (input.closest('.hm-campo').classList.contains('hm-campo-invalido')) validarCampo(input);
      });
    });

    form.addEventListener('submit', function (e) {
      var campos = form.querySelectorAll('[data-hm-validar]');
      var todoValido = true;
      campos.forEach(function (input) {
        if (!validarCampo(input)) todoValido = false;
      });
      if (!todoValido) {
        e.preventDefault();
        var primerInvalido = form.querySelector('.hm-campo-invalido input, .hm-campo-invalido textarea');
        if (primerInvalido) primerInvalido.focus();
      }
    });
  });
}

function hmInitCarrusel() {
  document.querySelectorAll('[data-hm-carrusel]').forEach(function (raiz) {
    var track = raiz.querySelector('[data-hc-track]');
    if (!track) return;
    var reales = Array.prototype.slice.call(track.querySelectorAll('[data-hc-slide]'));
    var n = reales.length;
    if (n === 0) return;

    var puntos = Array.prototype.slice.call(raiz.querySelectorAll('[data-hc-punto]'));
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (n === 1) { reales[0].classList.add('hc-activa'); return; }

    // Clones para bucle infinito
    var primero = reales[0].cloneNode(true);
    var ultimo = reales[n - 1].cloneNode(true);
    primero.setAttribute('aria-hidden', 'true');
    ultimo.setAttribute('aria-hidden', 'true');
    track.appendChild(primero);
    track.insertBefore(ultimo, reales[0]);

    var slides = Array.prototype.slice.call(track.children);
    var pos = 1;            // posición en 'slides' (1 = primer slide real)
    var normTimer = null;

    function colocar(anim) {
      var vp = raiz.querySelector('.hc-viewport').clientWidth;
      var s = slides[pos];
      var offset = s.offsetLeft + s.offsetWidth / 2 - vp / 2;
      track.classList.toggle('hc-no-anim', !anim || reduce);
      track.style.transform = 'translateX(' + (-offset) + 'px)';
      slides.forEach(function (el, i) { el.classList.toggle('hc-activa', i === pos); });
      var real = (pos - 1 + n) % n;
      puntos.forEach(function (p, i) {
        p.classList.toggle('hc-activo', i === real);
        p.setAttribute('aria-selected', i === real ? 'true' : 'false');
      });
    }

    // Si tras la transición estamos sobre un clon, saltamos (sin animación)
    // al slide real equivalente para que el bucle sea infinito y sin costuras.
    function normalizar() {
      if (pos === 0) { pos = n; colocar(false); }
      else if (pos === slides.length - 1) { pos = 1; colocar(false); }
    }

    function irA(p, anim) {
      pos = p;
      colocar(anim !== false);
      // transitionend es la vía normal; este timeout es un salvavidas por si
      // no llega (transición a un valor igual, pestaña en 2º plano, etc.),
      // para que el carrusel nunca se quede bloqueado.
      clearTimeout(normTimer);
      normTimer = setTimeout(normalizar, 620);
    }
    function siguiente() { irA(pos + 1); }
    function anterior() { irA(pos - 1); }

    track.addEventListener('transitionend', function (e) {
      if (e.target !== track) return;
      clearTimeout(normTimer);
      normalizar();
    });

    raiz.querySelectorAll('[data-hc-next]').forEach(function (b) { b.addEventListener('click', siguiente); });
    raiz.querySelectorAll('[data-hc-prev]').forEach(function (b) { b.addEventListener('click', anterior); });
    puntos.forEach(function (p) {
      p.addEventListener('click', function () {
        var i = parseInt(p.getAttribute('data-i'), 10) || 0;
        irA(i + 1);
      });
    });

    // Arrastre / swipe táctil
    var x0 = null;
    track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (dx < -40) siguiente();
      else if (dx > 40) anterior();
      x0 = null;
    });

    // Autoplay
    var timer = null;
    var auto = raiz.getAttribute('data-autoplay') === 'true' && !reduce;
    var ms = (parseInt(raiz.getAttribute('data-intervalo'), 10) || 5) * 1000;
    function arrancar() { if (auto && !timer) timer = setInterval(siguiente, ms); }
    function parar() { if (timer) { clearInterval(timer); timer = null; } }
    raiz.addEventListener('mouseenter', parar);
    raiz.addEventListener('mouseleave', arrancar);
    raiz.addEventListener('focusin', parar);
    raiz.addEventListener('focusout', arrancar);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) parar(); else arrancar();
    });

    window.addEventListener('resize', function () { colocar(false); });

    colocar(false);
    // segundo posicionamiento tras cargar imágenes (por si cambian de alto)
    window.addEventListener('load', function () { colocar(false); });
    setTimeout(function () { colocar(false); arrancar(); }, 60);
  });
}

if (!window.__hmScriptsInit) {
  window.__hmScriptsInit = true;
  document.addEventListener('DOMContentLoaded', function () {
    hmInitReveal();
    hmInitFaq();
    hmInitContacto();
    hmInitCarrusel();
    hmInitResenas();
  });
}
